
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import {BaseLayout, ProfileDrower} from 'components'
import { Auth } from "pages";

function App() {
  return (
    < >
      <ProfileDrower />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Auth/>} />
          <Route path="/p/*" element={<><BaseLayout/></>} />
        </Routes>
      </BrowserRouter>
    </>

  );
}

export default App;
